var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4a58d1e20ae878b795748bc5946df53f6088f297"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["maximilian-keller@maximilian-keller"]={id:"4a58d1e20ae878b795748bc5946df53f6088f297"};
      